
const productPopup = class extends HTMLElement {
  constructor() {
    super()

    this.popup = this.querySelector('dialog')
    this.productId = this.dataset.productId
    this.form = document.querySelector(`.shopify-section--main-product-v2 form[data-product-id="${this.productId}"]`)
      || document.querySelector(`form[data-product-id="${this.productId}"]`)
    this.subButton = this.querySelector('[data-subscribe-button]')
    this.buyButton = this.querySelector('[data-buy-once-button]')
    this.closeButton = this.querySelector('[data-popup-close]')
    this.enabled = this.dataset.enablePopup !== 'false'
    this.showFrequency = this.dataset.showFrequency || 'every_time'
    this.sessionKey = `product-popup-seen-${this.productId}`
    this.seenThisPage = false
    this.stop = false
    this._submitting = false
  }

  connectedCallback() {
    if (!this.form || !this.enabled) { return }

    this.subInput = this.form.querySelector('[data-subscription-option][value="subscribe"]')
    this.oneTimeInput = this.form.querySelector('[data-subscription-option][value="one-time"]')
    if (!this.subInput || !this.oneTimeInput) { return }

    try {
      sessionStorage.removeItem(this.sessionKey)
    } catch (error) {
      /* ignore */
    }

    this._onFormSubmit = (event) => {
      if (this.stop) {
        this.syncPurchaseOptions()
        return
      }

      this.syncPurchaseOptions()

      if (!this.oneTimeInput.checked) { return }

      // Already shown popup this visit — submit straight to cart.
      if (this.shouldSkipPopup()) { return }

      event.preventDefault()
      event.stopPropagation()
      this.handleSubmit()
    }

    this.form.addEventListener('submit', this._onFormSubmit, true)
    this.popup.addEventListener('click', (event) => {
      if (event.target === this.popup) {
        this.popup.close()
      }
    })

    this.closeButton?.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      this.popup.close()
    })

    this.subButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.subscribe()
    })

    this.buyButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.buyOnce()
    })
  }

  getSubscriptionsComponent() {
    return this.form?.querySelector('product-subscriptions-v2')
  }

  syncPurchaseOptions() {
    const component = this.getSubscriptionsComponent()
    if (!component) { return }

    component.syncPurchaseType(this.oneTimeInput.checked ? 'one-time' : 'subscribe')
  }

  shouldSkipPopup() {
    return this.showFrequency === 'once_per_session' && this.seenThisPage
  }

  markPopupSeenThisPage() {
    if (this.showFrequency === 'once_per_session') {
      this.seenThisPage = true
    }
  }

  handleSubmit() {
    this.popup.showModal()
    this.markPopupSeenThisPage()
  }

  subscribe() {
    this.subInput.checked = true
    this.subInput.dispatchEvent(new Event('change', { bubbles: true }))
    this.syncPurchaseOptions()
    this.submitForm()
  }

  buyOnce() {
    this.oneTimeInput.checked = true
    this.oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }))
    this.syncPurchaseOptions()
    this.submitForm()
  }

  submitForm() {
    if (this._submitting) { return }

    if (this.popup.open) {
      this.popup.close()
    }

    this.syncPurchaseOptions()
    this._submitting = true
    this.stop = true
    this.form.requestSubmit()
    this._submitting = false
    this.stop = false
  }
}

if (typeof window.customElements.get('product-popup') === 'undefined') {
  window.customElements.define('product-popup', productPopup)
}
